var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as debug from 'debug';
import { SocketService } from '@app/core/socket.service';
import { ReplyAbstractComponent } from '@app/shared/components/reply/reply-abstract.component';
import cardMap from '@app/games/shared/card-map';
import { BalanceHistoryService } from '@app/core/account/balance-history.service';
var MersenneTwister = require('mersennetwister');
var log = debug('edg:reply-video-poker');
var ReplyVideoPokerComponent = /** @class */ (function (_super) {
    __extends(ReplyVideoPokerComponent, _super);
    function ReplyVideoPokerComponent(socket, balanceHistory) {
        var _this = _super.call(this, socket, balanceHistory) || this;
        _this.socket = socket;
        _this.balanceHistory = balanceHistory;
        _this.data = null;
        _this.deck = [];
        _this.firstCards = [];
        _this.newCards = [];
        return _this;
    }
    ReplyVideoPokerComponent.prototype.initialize = function (data) {
        if (data.game !== 'video-poker') {
            this._error = true;
            return;
        }
        this.data = data.gameData;
        this.data.generated = false;
        this.data.game = 'video-poker';
        this.prepareDeck();
    };
    ReplyVideoPokerComponent.prototype.generateGame = function () {
        var deck = this.reconstructDeck(this.serverSeed, this.playerSeed);
        this.data = {
            shuffledDeck: deck,
            generated: true,
            game: 'video-poker',
        };
        this.prepareDeck();
    };
    ReplyVideoPokerComponent.prototype.prepareDeck = function () {
        this.firstCards = this.data.shuffledDeck.slice(0, 5);
        this.newCards = this.data.shuffledDeck.slice(5, 10);
        this._loading = false;
    };
    ReplyVideoPokerComponent.prototype.getCardName = function (card) {
        return cardMap[card % 52];
    };
    ReplyVideoPokerComponent.prototype.reconstructDeck = function (srvSeed, clientSeed) {
        var deck = [];
        for (var i = 0; i < 52; i++) {
            // 1 deck
            deck.push(i);
        }
        return this.shuffleDeck(deck, srvSeed, clientSeed);
    };
    ReplyVideoPokerComponent.prototype.shuffleDeck = function (deck, serverSeed, clientSeed) {
        serverSeed = serverSeed.replace('0x', '');
        clientSeed = clientSeed.replace('0x', '');
        var clSeedSplitted = clientSeed.match(/.{1,6}/g);
        var srvSeedSplitted = serverSeed.match(/.{1,6}/g);
        var seedsCombined = clSeedSplitted.concat(srvSeedSplitted).map(function (item) { return parseInt(item, 16); });
        var mt = new MersenneTwister();
        mt.seedArray(seedsCombined);
        for (var i = 0; i < 800000; i++) {
            mt.real();
        }
        var shuffledDeck = deck.slice(0);
        for (var i = shuffledDeck.length - 1; i > 0; i -= 1) {
            var j = Math.floor(mt.real() * (i + 1));
            var temp = shuffledDeck[i];
            shuffledDeck[i] = shuffledDeck[j];
            shuffledDeck[j] = temp;
        }
        return shuffledDeck;
    };
    return ReplyVideoPokerComponent;
}(ReplyAbstractComponent));
export { ReplyVideoPokerComponent };



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/shared/components/reply/reply-video-poker.component.ts.pre-build-optimizer.js